/* eslint-disable */
require('./add')
require('./added')
require('./arrow-right')
require('./arrow-rounded-down')
require('./arrow-rounded')
require('./attention')
require('./box')
require('./check-thin')
require('./check')
require('./close')
require('./cross')
require('./delivery')
require('./dropshipment')
require('./expand')
require('./facebook')
require('./factory')
require('./file-image')
require('./file-pdf')
require('./graphs')
require('./group-people')
require('./info')
require('./instagram')
require('./lamp')
require('./logout')
require('./mail')
require('./message')
require('./phone')
require('./play')
require('./removed')
require('./reset')
require('./search')
require('./shopping-cart')
require('./sort')
require('./twitter')
require('./user')



// WEBPACK FOOTER //
// ./src/assets/dist/icons/index.js